import { httpwmsapi } from 'src/services';
import queryString from 'query-string';

// Action Types
export const Types = {
  STOCK_ADDRESSES_LOADING: 'stock_addresses/loading',
  STOCK_ADDRESSES_SET_ADDRESSES: 'stock_addresses/set/addresses',
  STOCK_ADDRESSES_SET_PAGING: 'stock_addresses/set/paging',
  STOCK_ADDRESSES_SET_FILTERS: 'stock_addresses/set/filters',
};

// Reducer
const initialState = {
  loading: false,
  stock_addresses: [],
  stock_addresses_paging: { limit: 25, offset: 0, total: 0 },
  stock_addresses_filters: {
    block: '',
    street: '',
    apartment: '',
    tower: '',
    floor: '',
    mult: '',
    type: '',
    active: 'S',
    allow_picking: '',
    allow_picking_fulfillment: '',
  },
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.STOCK_ADDRESSES_LOADING:
      return { ...state, loading: action.payload };
    case Types.STOCK_ADDRESSES_SET_ADDRESSES:
      return { ...state, stock_addresses: action.payload };
    case Types.STOCK_ADDRESSES_SET_PAGING:
      return { ...state, stock_addresses_paging: action.payload };
    case Types.STOCK_ADDRESSES_SET_FILTERS:
      return { ...state, stock_addresses_filters: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  stockAddressesLoading: (value) => ({
    type: Types.STOCK_ADDRESSES_LOADING,
    payload: value,
  }),
  stockAddressesSetAddresses: (value) => ({
    type: Types.STOCK_ADDRESSES_SET_ADDRESSES,
    payload: value,
  }),
  stockAddressesSetPaging: (value) => ({
    type: Types.STOCK_ADDRESSES_SET_PAGING,
    payload: value,
  }),
  stockAddressesSetFilters: (value) => ({
    type: Types.STOCK_ADDRESSES_SET_FILTERS,
    payload: value,
  }),
  createStorageAddress: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/estoque-endereco`, body, { timeout: 1000 * 90 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  updateStorageAddress: (address_id, body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(`/v1/estoque-endereco/${address_id}`, body, { timeout: 1000 * 30 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getStockAddressPdf: (ids) => {
    return new Promise((resolve, reject) => {
      if (ids?.length > 1) {
        httpwmsapi
          .get(`/v1/estoque-endereco/label-pdf/ids/${ids}`, {
            timeout: 1000 * 30,
          })
          .then(({ data }) => resolve(data))
          .catch((error) => reject(error));
      } else {
        httpwmsapi
          .get(`/v1/estoque-endereco/label-pdf/${ids}`, {
            timeout: 1000 * 30,
          })
          .then(({ data }) => resolve(data))
          .catch((error) => reject(error));
      }
    });
  },
  getStorageAddressList: (storage_id, filters, paging) => {
    const filtersQuery = queryString.stringify(filters, { arrayFormat: 'index' });
    const pagingQuery = queryString.stringify(paging, { arrayFormat: 'index' });

    const query = [filtersQuery, pagingQuery].filter((part) => part.length > 0).join('&');

    return httpwmsapi
      .get(`/v1/estoque-endereco/${storage_id}/addresses?${query}`, { timeout: 1000 * 60 })
      .then(({ data }) => data);
  },
};
